const lastNameValidation = value => {
  if (!value) {
    return { lastName: '*Required' };
  } else if (!/^[a-zA-Z._. ,'&-]{1,50}$/.test(value)) {
    return { lastName: '*Invalid Last Name' };
  }
  return {};
};

export default lastNameValidation;



// WEBPACK FOOTER //
// ./src/components/Forms/Validations/lastNameValidation.js